import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from '@/api/axios'
import VueAxios from 'vue-axios'
import './static/css/style.css'
import Common from '../src/api/common'
import moment from 'moment'
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import vueAudio from 'vue-mobile-audio'
import myAudio from './components/audio/audio.vue'
import 'vue-mini-player/lib/vue-mini-player.css'
import OpenApp from './api/openApp'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;
Vue.component("my-audio", myAudio);
Vue.use(vueAudio)
function guid() {
   if (window.localStorage.getItem('uuid')) {
      return window.localStorage.getItem('uuid')
   } else {
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
         var r = Math.random() * 16 | 0,
             v = c == 'x' ? r : (r & 0x3 | 0x8);
         return v.toString(16);
     });
      window.localStorage.setItem('uuid',uuid);
      return window.localStorage.getItem('uuid')
   }
}

Vue.prototype.uuid = guid()
NutUI.install(Vue);
Vue.use(MintUI)
Vue.config.productionTip = false
Vue.prototype.common = Common;
import vueMiniPlayer from 'vue-mini-player'
Vue.use(vueMiniPlayer)
// 全局打开app方法
Vue.prototype.openApp = OpenApp
Vue.download = () => {
   const user_agent = navigator.userAgent.toLocaleLowerCase();
   if (this.common.isAndroid(user_agent)) {
      console.log("安卓");
      window.location.href =
         "https://sj.qq.com/myapp/detail.htm?apkName=com.huyang.aidu";
   } else if (this.common.isIOS(user_agent)) {
      console.log("ios");
      window.location.href =
         "https://itunes.apple.com/cn/app/apple-store/id1466586027";
   } else {
      console.log("什么都不是");
      window.location.href = "";
   }
},

   Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD') {
      return moment(dataStr).format(pattern)

   })
Vue.filter('stringcut', function (val) {
   if (val.length > 20) {
      return val.substr(0, 17) + "..."
   } else {
      return val
   }
})
Vue.filter('stringSub', function (val, num) {
   if (val.length > num) {
      return val.substr(0, num) + "..."
   } else {
      return val
   }
})
Vue.filter('isUrl', function (val) {
   if (val.substr(0, 7).toLowerCase() == "http://" || val.substr(0, 8).toLowerCase() == "https://") {
      return val
   } else {
      return 'https://media.91idu.com/' + val
   }
})
Vue.filter('yuan', function (val) {
   let str = (val / 100).toFixed(2) + '';

   // let intSum = str.substring(0,str.indexOf(".")).replace( /\B(?=(?:\d{3})+$)/g, ',' );//取到整数部分
   // let dot = str.substring(str.length,str.indexOf("."))//取到小数部分
   // let ret = intSum + dotstr;
   return str
})
Vue.filter('duration', function realFormatSecond(second) {
   let secondType = typeof second
   if (secondType === 'number' || secondType === 'string') {
      second = parseInt(second)
      let hours = Math.floor(second / 3600)
      second = second - hours * 3600
      let mimute = Math.floor(second / 60)
      second = second - mimute * 60
      return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
   } else {
      return '00:00'
   }
})

Vue.use(VueAxios, axios)
new Vue({
   render: h => h(App),
   router,
}).$mount('#app')
